import { default as _91customerId_93HkanUypwRcMeta } from "/usr/src/app/pages/administration/customers/[customerId].vue?macro=true";
import { default as index5LtKnKu5VfMeta } from "/usr/src/app/pages/administration/customers/index.vue?macro=true";
import { default as _91deviceId_933Ra1Jd5vuBMeta } from "/usr/src/app/pages/administration/devices/[deviceId].vue?macro=true";
import { default as createOaLrHO5kogMeta } from "/usr/src/app/pages/administration/devices/create.vue?macro=true";
import { default as indexSE3ch2W5mHMeta } from "/usr/src/app/pages/administration/devices/index.vue?macro=true";
import { default as indexhesXSAAWYdMeta } from "/usr/src/app/pages/administration/hub-message-viewer/index.vue?macro=true";
import { default as indexnMNUgWRJc2Meta } from "/usr/src/app/pages/administration/index.vue?macro=true";
import { default as _91machineId_93LQ3pzisI4OMeta } from "/usr/src/app/pages/alerts/index/[machineId].vue?macro=true";
import { default as awaiting_45operatorS7wrTaEq5dMeta } from "/usr/src/app/pages/alerts/index/awaiting-operator.vue?macro=true";
import { default as delivery_45failedAyIbwnLrAJMeta } from "/usr/src/app/pages/alerts/index/delivery-failed.vue?macro=true";
import { default as machine_45alertsoV3eiQE4MzMeta } from "/usr/src/app/pages/alerts/index/machine-alerts.vue?macro=true";
import { default as unreadYa3ovEwMDDMeta } from "/usr/src/app/pages/alerts/index/unread.vue?macro=true";
import { default as indexYVv8XYHaH9Meta } from "/usr/src/app/pages/alerts/index.vue?macro=true";
import { default as indexnWuJsJtusBMeta } from "/usr/src/app/pages/analysis/historic/index.vue?macro=true";
import { default as indexWwqGR12ImEMeta } from "/usr/src/app/pages/analysis/index.vue?macro=true";
import { default as index0mgGT5iMA7Meta } from "/usr/src/app/pages/analysis/live/index.vue?macro=true";
import { default as indexcZdylDgCEwMeta } from "/usr/src/app/pages/analysis/report/index.vue?macro=true";
import { default as contact_45usAdrVxg0OvLMeta } from "/usr/src/app/pages/contact-us.vue?macro=true";
import { default as dashboardhKii8fXWAxMeta } from "/usr/src/app/pages/dashboard.vue?macro=true";
import { default as forbidden8QxDTmsbsYMeta } from "/usr/src/app/pages/forbidden.vue?macro=true";
import { default as loginRGcvZC480vMeta } from "/usr/src/app/pages/login.vue?macro=true";
import { default as _91machineId_93PUHDbzo2wUMeta } from "/usr/src/app/pages/machines/[machineId].vue?macro=true";
import { default as indexWGezfBYh01Meta } from "/usr/src/app/pages/machines/index.vue?macro=true";
import { default as ownershipnKDaJ0qGzaMeta } from "/usr/src/app/pages/machines/ownership.vue?macro=true";
import { default as oidc_45callbackgCluCVGDTMMeta } from "/usr/src/app/pages/oidc-callback.vue?macro=true";
import { default as _91projectId_938fTOLUPOXBMeta } from "/usr/src/app/pages/projects/[projectId].vue?macro=true";
import { default as createTlP28oYuwYMeta } from "/usr/src/app/pages/projects/create.vue?macro=true";
import { default as indexsjG9qRz3rlMeta } from "/usr/src/app/pages/projects/index.vue?macro=true";
import { default as worksitesCardmf875hIUUHMeta } from "/usr/src/app/pages/projects/worksitesCard.vue?macro=true";
import { default as upgrade_45intermediateDTdQ2UVNPtMeta } from "/usr/src/app/pages/upgrade-intermediate.vue?macro=true";
import { default as upgrade_45premiumgglR1JRq8yMeta } from "/usr/src/app/pages/upgrade-premium.vue?macro=true";
import { default as component_45stubuYxk0V0rW5Meta } from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubuYxk0V0rW5 } from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "administration-customers-customerId",
    path: "/administration/customers/:customerId()",
    meta: _91customerId_93HkanUypwRcMeta || {},
    component: () => import("/usr/src/app/pages/administration/customers/[customerId].vue").then(m => m.default || m)
  },
  {
    name: "customers",
    path: "/administration/customers",
    meta: index5LtKnKu5VfMeta || {},
    component: () => import("/usr/src/app/pages/administration/customers/index.vue").then(m => m.default || m)
  },
  {
    name: "administration-devices-deviceId",
    path: "/administration/devices/:deviceId()",
    meta: _91deviceId_933Ra1Jd5vuBMeta || {},
    component: () => import("/usr/src/app/pages/administration/devices/[deviceId].vue").then(m => m.default || m)
  },
  {
    name: "administration-devices-create",
    path: "/administration/devices/create",
    meta: createOaLrHO5kogMeta || {},
    component: () => import("/usr/src/app/pages/administration/devices/create.vue").then(m => m.default || m)
  },
  {
    name: "devices",
    path: "/administration/devices",
    meta: indexSE3ch2W5mHMeta || {},
    component: () => import("/usr/src/app/pages/administration/devices/index.vue").then(m => m.default || m)
  },
  {
    name: "administration-hub-message-viewer",
    path: "/administration/hub-message-viewer",
    meta: indexhesXSAAWYdMeta || {},
    component: () => import("/usr/src/app/pages/administration/hub-message-viewer/index.vue").then(m => m.default || m)
  },
  {
    name: "administration",
    path: "/administration",
    meta: indexnMNUgWRJc2Meta || {},
    component: () => import("/usr/src/app/pages/administration/index.vue").then(m => m.default || m)
  },
  {
    name: "alerts",
    path: "/alerts",
    meta: indexYVv8XYHaH9Meta || {},
    component: () => import("/usr/src/app/pages/alerts/index.vue").then(m => m.default || m),
    children: [
  {
    name: "alerts-index-machineId",
    path: ":machineId()",
    meta: _91machineId_93LQ3pzisI4OMeta || {},
    component: () => import("/usr/src/app/pages/alerts/index/[machineId].vue").then(m => m.default || m)
  },
  {
    name: "alerts-index-awaiting-operator",
    path: "awaiting-operator",
    meta: awaiting_45operatorS7wrTaEq5dMeta || {},
    component: () => import("/usr/src/app/pages/alerts/index/awaiting-operator.vue").then(m => m.default || m)
  },
  {
    name: "alerts-index-delivery-failed",
    path: "delivery-failed",
    meta: delivery_45failedAyIbwnLrAJMeta || {},
    component: () => import("/usr/src/app/pages/alerts/index/delivery-failed.vue").then(m => m.default || m)
  },
  {
    name: "alerts-index-machine-alerts",
    path: "machine-alerts",
    meta: machine_45alertsoV3eiQE4MzMeta || {},
    component: () => import("/usr/src/app/pages/alerts/index/machine-alerts.vue").then(m => m.default || m)
  },
  {
    name: "alerts-index-unread",
    path: "unread",
    meta: unreadYa3ovEwMDDMeta || {},
    component: () => import("/usr/src/app/pages/alerts/index/unread.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "analysis-historic",
    path: "/analysis/historic",
    component: () => import("/usr/src/app/pages/analysis/historic/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis",
    path: "/analysis",
    meta: indexWwqGR12ImEMeta || {},
    component: () => import("/usr/src/app/pages/analysis/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-live",
    path: "/analysis/live",
    component: () => import("/usr/src/app/pages/analysis/live/index.vue").then(m => m.default || m)
  },
  {
    name: "analysis-report",
    path: "/analysis/report",
    component: () => import("/usr/src/app/pages/analysis/report/index.vue").then(m => m.default || m)
  },
  {
    name: "contact-us",
    path: "/contact-us",
    meta: contact_45usAdrVxg0OvLMeta || {},
    component: () => import("/usr/src/app/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/usr/src/app/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: "forbidden",
    path: "/forbidden",
    meta: forbidden8QxDTmsbsYMeta || {},
    component: () => import("/usr/src/app/pages/forbidden.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: loginRGcvZC480vMeta || {},
    component: () => import("/usr/src/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "machines-machineId",
    path: "/machines/:machineId()",
    meta: _91machineId_93PUHDbzo2wUMeta || {},
    component: () => import("/usr/src/app/pages/machines/[machineId].vue").then(m => m.default || m)
  },
  {
    name: "machines",
    path: "/machines",
    component: () => import("/usr/src/app/pages/machines/index.vue").then(m => m.default || m)
  },
  {
    name: "machines-ownership",
    path: "/machines/ownership",
    component: () => import("/usr/src/app/pages/machines/ownership.vue").then(m => m.default || m)
  },
  {
    name: "oidc-callback",
    path: "/oidc-callback",
    meta: oidc_45callbackgCluCVGDTMMeta || {},
    component: () => import("/usr/src/app/pages/oidc-callback.vue").then(m => m.default || m)
  },
  {
    name: "projects-projectId",
    path: "/projects/:projectId()",
    meta: _91projectId_938fTOLUPOXBMeta || {},
    component: () => import("/usr/src/app/pages/projects/[projectId].vue").then(m => m.default || m)
  },
  {
    name: "projects-create",
    path: "/projects/create",
    meta: createTlP28oYuwYMeta || {},
    component: () => import("/usr/src/app/pages/projects/create.vue").then(m => m.default || m)
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/usr/src/app/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: "projects-worksitesCard",
    path: "/projects/worksitesCard",
    component: () => import("/usr/src/app/pages/projects/worksitesCard.vue").then(m => m.default || m)
  },
  {
    name: "upgrade-intermediate",
    path: "/upgrade-intermediate",
    component: () => import("/usr/src/app/pages/upgrade-intermediate.vue").then(m => m.default || m)
  },
  {
    name: "upgrade-premium",
    path: "/upgrade-premium",
    component: () => import("/usr/src/app/pages/upgrade-premium.vue").then(m => m.default || m)
  },
  {
    name: component_45stubuYxk0V0rW5Meta?.name,
    path: "/",
    component: component_45stubuYxk0V0rW5
  }
]